/*
 * claw-cursor.js
 * Custom cursor overlay: an arrow everywhere, a clapping lobster claw over
 * anything interactive. Rendered by snippets/claw-cursor.liquid. Desktop,
 * fine pointer only; the native cursor is hidden only once the art has
 * decoded and the mouse has moved, so it can never leave the page cursorless.
 */
(function () {
  var root = document.documentElement;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var wrap = document.querySelector('.claw-cursor');
  if (!wrap) return;

  var arrow = wrap.querySelector('.claw-cursor__arrow');
  var claw = wrap.querySelector('.claw-cursor__claw');
  var imgs = Array.prototype.slice.call(wrap.querySelectorAll('img[data-src]'));
  var TARGETS = 'a, button, label, summary, select, input, textarea, [data-claw], [role="button"]' + (wrap.dataset.targets ? ', ' + wrap.dataset.targets : '');
  var x = 0;
  var y = 0;
  var queued = false;
  var decoded = false;
  var ready = false;

  imgs.forEach(function (img) {
    img.src = img.getAttribute('data-src');
  });

  Promise.all(imgs.map(function (img) {
    return img.decode ? img.decode() : Promise.resolve();
  }))
    .then(function () {
      decoded = true;
    })
    .catch(function () {
      if (window.console && console.warn) console.warn('[claw-cursor] cursor art failed to load; keeping the native cursor');
    });

  function paint() {
    var t = 'translate(' + x + 'px, ' + y + 'px)';
    arrow.style.transform = t;
    claw.style.transform = t;
    queued = false;
  }

  document.addEventListener('mousemove', function (e) {
    if (!decoded) return;
    x = e.clientX;
    y = e.clientY;
    if (!ready) {
      ready = true;
      paint();
      root.classList.add('claw-cursor-ready');
    }
    if (!queued) {
      queued = true;
      requestAnimationFrame(paint);
    }
    /* Disabled controls get the arrow: there's nothing to grab. */
    var onTarget = !!(e.target.closest && e.target.closest(TARGETS) && !e.target.closest(':disabled, [aria-disabled="true"]'));
    claw.classList.toggle('is-on', onTarget);
    arrow.classList.toggle('is-on', !onTarget);
  }, { passive: true });

  document.documentElement.addEventListener('mouseleave', function () {
    claw.classList.remove('is-on');
    arrow.classList.remove('is-on');
  });

  document.addEventListener('mousedown', function () {
    claw.classList.add('is-down');
  });

  document.addEventListener('mouseup', function () {
    claw.classList.remove('is-down');
  });
})();
